import { render, staticRenderFns } from "./new-customers-card.vue?vue&type=template&id=03b75bae&"
import script from "./new-customers-card.vue?vue&type=script&lang=js&"
export * from "./new-customers-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports